import script from "./landlord-switching-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./landlord-switching-modal.vue?vue&type=script&setup=true&lang=ts"

import "./landlord-switching-modal.vue?vue&type=style&index=0&id=1242e066&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1242e066"]])

export default __exports__